/* VEROCONIC v48: collection-page random product order.
   Runs only when no customer sort_by is explicitly selected. Filters/pagination remain intact. */
(function () {
  'use strict';

  function hasExplicitSort() {
    try { return new URL(window.location.href).searchParams.has('sort_by'); }
    catch (e) { return /(?:\\?|&)sort_by=/.test(window.location.search); }
  }

  function randomInt(max) {
    if (window.crypto && window.crypto.getRandomValues) {
      var a = new Uint32Array(1);
      window.crypto.getRandomValues(a);
      return a[0] % max;
    }
    return Math.floor(Math.random() * max);
  }

  function shuffleGrid(grid) {
    if (!grid || grid.dataset.veroconicRandomize !== 'true' || grid.dataset.veroconicShuffled === 'true') return;
    if (hasExplicitSort()) return;

    var products = Array.prototype.filter.call(grid.children, function (el) {
      return el.nodeType === 1 && el.classList.contains('grid__item') && !el.classList.contains('promotion');
    });
    if (products.length < 2) return;

    grid.dataset.veroconicShuffled = 'true';
    var slots = products.map(function (el) {
      var marker = document.createComment('veroconic-product-slot');
      el.parentNode.insertBefore(marker, el);
      el.parentNode.removeChild(el);
      return marker;
    });

    for (var i = products.length - 1; i > 0; i--) {
      var j = randomInt(i + 1);
      var t = products[i]; products[i] = products[j]; products[j] = t;
    }

    slots.forEach(function (marker, index) {
      marker.parentNode.replaceChild(products[index], marker);
    });
  }

  function run(root) {
    root = root || document;
    if (root.matches && root.matches('#product-grid[data-veroconic-randomize="true"]')) shuffleGrid(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('#product-grid[data-veroconic-randomize="true"]').forEach(shuffleGrid);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ run(document); });
  else run(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (node) {
        if (node.nodeType === 1) run(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
